import React from "react";

const Error = ({ err }) => {
  return <div>{err}</div>;
};

export default Error;
